<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="pa-3">
          <!-- <v-layout row wrap>
            <v-flex md4 class="pl-1">
              <v-menu
                v-model="invoiceDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.month"
                    label="Report Month"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.month"
                  @input="invoiceDateMenu = false"
                  type="month"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout> -->

          
          <v-layout row wrap>
            <v-flex md3 class="pl-1">
              <v-menu
                v-model="invoiceDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date"
                    label="Date From"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.date"
                  @input="invoiceDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md3 class="pl-1">
              <v-menu
                v-model="invoiceDateMenu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date2"
                    label="Date To"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="reportFilters.date"
                  v-model="reportFilters.date2"
                  @input="invoiceDateMenu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md6 class="text-xs-right">
              <!-- <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="primary"
                    fab
                    small
                    dark
                    @click="isSearchModal = true"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Advance Search</span>
              </v-tooltip> -->
            </v-flex>
          </v-layout>

          <ListLoader v-if="isLoadingContent"></ListLoader>
          <div class="simple-table-container" id="daily-receive-report" v-else>
            <!-- <div class="headline hidden-screen-only">
              {{ settings && settings.company_name }}
            </div>
            <div class="subheading hidden-screen-only">
              {{ settings && settings.company_address }}
            </div>
            <div class="title pb-3 hidden-screen-only">
              Cash outflows -
              {{ $moment(`${reportFilters.month}-01`).format("MMMM - YYYY") }}
            </div>
            <table class="table table-bordered">
              <tr>
                <th>Particulars</th>
                <th>Amount</th>
              </tr>
              <tr>
                <td colspan="2"><strong>Incomes</strong></td>
              </tr>
              <tr v-for="(item, index) in inALL" :key="`in_all_${index}`">
                <td>{{ item.particulars }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              <tr>
                <td align="right"><strong>Total Incomes</strong></td>
                <td>
                  <strong>{{ inALL.reduce((s, f) => s + f.amount, 0) }}</strong>
                </td>
              </tr>

              <tr>
                <td colspan="2"><strong>Loans</strong></td>
              </tr>
              <tr v-for="(item, index) in inLoans" :key="`in_loans_${index}`">
                <td>{{ item.particulars }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              <tr>
                <td align="right"><strong>Total Lones</strong></td>
                <td>
                  <strong>{{
                    inLoans.reduce((s, f) => s + f.amount, 0)
                  }}</strong>
                </td>
              </tr>

              <tr>
                <td align="right"><strong>Grand Total Income</strong></td>
                <td>
                  <strong>{{
                    inLoans.reduce((s, f) => s + f.amount, 0) +
                    inALL.reduce((s, f) => s + f.amount, 0)
                  }}</strong>
                </td>
              </tr>

              <tr>
                <td colspan="2"><strong>Expenses</strong></td>
              </tr>
              <tr v-for="(item, index) in outALL" :key="`out_all_${index}`">
                <td>{{ item.particulars }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              <tr>
                <td align="right"><strong>Total Expenses</strong></td>
                <td>
                  <strong>{{
                    outALL.reduce((s, f) => s + f.amount, 0)
                  }}</strong>
                </td>
              </tr>

              <tr>
                <td colspan="2"><strong>Loan returns</strong></td>
              </tr>
              <tr v-for="(item, index) in outLoans" :key="`out_loans_${index}`">
                <td>{{ item.particulars }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              <tr>
                <td align="right"><strong>Total Lone Returns</strong></td>
                <td>
                  <strong>{{
                    outLoans.reduce((s, f) => s + f.amount, 0)
                  }}</strong>
                </td>
              </tr>

              <tr>
                <td align="right"><strong>Grand Total Expenses</strong></td>
                <td>
                  <strong>{{ outGrandSum }}</strong>
                </td>
              </tr>

              <tr>
                <td colspan="2" class="report-sum text-center">
                  Actual Net Profit/(Loss) &nbsp;&nbsp; tk.
                  {{ netProfitLoss }}
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <strong>Department Overview</strong>
                </td>
              </tr>
              <tr
                v-for="(item, index) in deptOverviewRows"
                :key="`dept_ov_${index}`"
              >
                <td>{{ item.particulars }}</td>
                <td>{{ item.amount }}</td>
              </tr>
            </table> -->
            <!-- {{ deptOverviewRows }} -->

            <div class="hidden-screen-only report-header text-center">
              <div class="head">
                {{ settings && settings.company_name }}
              </div>
              <div class="address">
                {{ settings && settings.company_address }}
              </div>
              <hr />
              <br />
              <div class="title">
                Balance On report of
                {{
                  reportFilters.date == reportFilters.date2
                    ? reportFilters.date
                    : `${reportFilters.date} to ${reportFilters.date2}`
                }}
              </div>
            </div>

            <h5 align="center" class="title pt-3 pb-2">Expenses</h5>
            <table class="table table-bordered">
              <tr>
                <th style="width: 70%">Account Head</th>
                <th style="width: 30%">Amount</th>
              </tr>
              <tr v-for="item in payments" :key="item.id">
                <td>{{ item.account_heads___title }}</td>
                <td>{{ item.amount_sum }}</td>
              </tr>
              <tr>
                <td colspan="6" class="report-sum text-center">
                  Total Expense &nbsp;&nbsp; tk. {{ paymentsSum }}
                </td>
              </tr>
            </table>
            <h5 align="center" class="title pt-3 pb-2">Incomes</h5>
            <table class="table table-bordered">
              <tr>
                <th style="width: 70%">Account Head</th>
                <th style="width: 30%">Amount</th>
              </tr>
              <tr v-for="item in received" :key="item.id">
                <td>{{ item.account_heads___title }}</td>
                <td>{{ item.amount_sum }}</td>
              </tr>
              <tr>
                <td colspan="6" class="report-sum text-center">
                  Total Received &nbsp;&nbsp; tk. {{ receivesSum }}
                </td>
              </tr>
              <tr>
                <td colspan="6" class="report-sum text-center">
                Balance On
                  <!-- Profit/Loss  -->
                  <!-- <strong v-if="profitAmount>0" style="color:green;">(Profit)</strong> 
                  <strong v-if="profitAmount<0" style="color:red;">(Loss)</strong>  -->
                  &nbsp;&nbsp; tk. {{ profitAmount }}
                </td>
              </tr>
            </table>
          </div>
          <v-card-actions>
            <v-btn flat @click="print()">Print</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _ from "underscore";
import CFR from "./report_parts/CashFlowRows";
import { ContentLoader, ListLoader } from "vue-content-loader";
import { columnSum } from "../../mdsir/MdsirUtils";
import { MYSQL_DATE_FORMAT } from "../../mdsir/const";

export default {
  components: {
    CFR,
    ListLoader,
  },
  data: () => ({
    isLoadingContent: false,
    invoiceDateMenu: false,
    reportFilters: {
      // month: new Date().toISOString().substr(0, 7),
      date: null,
      date2: null,
    },
    depGroupedExpensesAllType: {},
    reportData: [],
    rowS: [],
    reportSum: 0,
    inALL: [],
    outALL: [],
    inLoans: [],
    outLoans: [],
    received: [],
    payments: [],
  }),

  computed: {
    // reportSum() {
    //   return this.reportData.reduce(function (prev, cur) {
    //     return prev + cur.amount;
    //   }, 0);
    //   return 0;
    // },
    receivesSum() {
      return columnSum(this.received, "amount_sum");
    },
    paymentsSum() {
      return columnSum(this.payments, "amount_sum");
    },
    profitAmount() {
      return this.receivesSum - this.paymentsSum;
    },
    inLoansSum() {
      return this.inLoans.reduce((s, f) => s + f.amount, 0);
    },
    inALLSum() {
      return this.inALL.reduce((s, f) => s + f.amount, 0);
    },
    inGrandSum() {
      return this.inLoansSum + this.inALLSum;
    },
    outLoansSum() {
      return this.outLoans.reduce((s, f) => s + f.amount, 0);
    },
    outALLSum() {
      return this.outALL.reduce((s, f) => s + f.amount, 0);
    },
    outGrandSum() {
      return this.outLoansSum + this.outALLSum;
    },
    netProfitLoss() {
      let balance = this.inGrandSum - this.outGrandSum;
      return balance >= 0 ? balance : `(${Math.abs(balance)})`;
    },

    deptOverviewRows() {
      let out_all = this.outALL.map((row) => {
        let plainRow = _.clone(row);
        plainRow.amount = row.amount * -1;
        return plainRow;
      });

      let in_all = this.inALL.map((row) => _.clone(row));
      let in_out_all = out_all.concat(in_all);
      let in_out_all_grouped = _.groupBy(in_out_all, "particulars");

      const mapped = _.mapObject(in_out_all_grouped, function (val, key) {
        let balance = val.reduce((s, f) => s + f.amount, 0);
        balance = balance >= 0 ? balance : `(${Math.abs(balance)})`;
        return {
          department_id: val[0]["department_id"],
          particulars: val[0]["particulars"],
          amount: balance,
        };
      });

      return _.toArray(mapped);
    },
  },

  watch: {
    reportFilters: {
      handler: function (val, oldVal) {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {
    this.reportFilters.date = this.$moment().startOf("month").format(MYSQL_DATE_FORMAT);
    this.reportFilters.date2 = this.$moment().endOf("month").format(MYSQL_DATE_FORMAT);
    // this.getDataFromApi();
  },

  methods: {
    getDataFromApi() {
      this.isLoadingContent = true;
      this.get("/profit_loss_monthly_report", this.reportFilters).then((response) => {
        // this.setResponseData(response.data);
        // this.inALL = response.data.in_all;
        // this.outALL = response.data.out_all;
        // this.inLoans = response.data.loans_in;
        // this.outLoans = response.data.loans_out;
        this.received = response.data.received;
        this.payments = response.data.payments;
        this.isLoadingContent = false;
      });
    },

    setResponseData(resData) {
      this.reportData = resData;
      // console.log(response.data.invoices);
      const bills = resData.bills;
      const expenses = resData.expenses;
      const expensesAllType = resData.expenses_all_type;

      let sumExpensesAllType = expensesAllType.reduce(function (prev, cur) {
        return prev + cur.amount;
      }, 0);

      const depGroupedExpensesAllType = _.groupBy(expensesAllType, "departments___title");

      const mapped = _.mapObject(depGroupedExpensesAllType, function (val, key) {
        let sum = val.reduce(function (prev, cur) {
          return prev + cur.amount;
        }, 0);

        val.unshift({ group_dept_name: key });
        val.push({ group_dept_name_sum: key, group_sum_amount: sum });
        return val;
      });

      let loans = resData.loans;
      let sumLoans = loans.reduce(function (prev, cur) {
        return prev + cur.amount;
      }, 0);
      loans.unshift({ group_dept_name: "Loan Account" });
      loans.push({
        group_dept_name_sum: "Loan Account",
        group_sum_amount: sumLoans,
      });

      let rowS = _.flatten(_.toArray(mapped));
      const mergedRows = rowS.concat(loans);
      this.rowS = mergedRows;
      this.reportSum = sumExpensesAllType + sumLoans;

      // console.log("inoices: ", rowS);

      // console.log("loans", loans);
      // console.log("Merged: ", mergedRows);
    },
    print() {
      this.$htmlToPaper("daily-receive-report");
    },
  },

  beforeDestroy() {},
};
</script>

<style scopped>
.simple-table-container {
  overflow: auto;
}
.simple-table-container .table {
  border-collapse: collapse;
  width: 100%;
}
.simple-table-container .table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #bebebe;
}

.simple-table-container .table td,
.simple-table-container .table th {
  border: 1px solid #ddd;
  padding: 8px;
}

.simple-table-container .table td.report-sum {
  padding: 6px;
  text-align: center;
  background-color: #0f0f0f0e;
  font-size: 20px;
  font-weight: bold;
}
</style>
